import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type ThemeMode = 'dark' | 'light';

interface UiState {
  theme: ThemeMode;
  commandPaletteOpen: boolean;
  sidebarCollapsed: boolean;
  setTheme: (theme: ThemeMode) => void;
  toggleTheme: () => void;
  setCommandPaletteOpen: (open: boolean) => void;
  toggleSidebarCollapsed: () => void;
}

const safeStorage =
  typeof window !== 'undefined'
    ? createJSONStorage(() => window.localStorage)
    : undefined;

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      theme: 'dark',
      commandPaletteOpen: false,
      sidebarCollapsed: false,
      setTheme: (theme) => set({ theme }),
      toggleTheme: () => set((state) => ({ theme: state.theme === 'dark' ? 'light' : 'dark' })),
      setCommandPaletteOpen: (commandPaletteOpen) => set({ commandPaletteOpen }),
      toggleSidebarCollapsed: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
    }),
    {
      name: 'nordiccompanyhub-ui',
      storage: safeStorage,
      partialize: ({ theme, sidebarCollapsed }) => ({ theme, sidebarCollapsed }),
    },
  ),
);
